import { Tag } from "bbcode-to-react";
class IdentityTag extends Tag {
    toHTML() {
        return [this.getContent()];
    }
    toReact() {
        return this.getComponents();
    }
}
export default IdentityTag;
